import React, { useState } from 'react';
import { api } from '../hooks/useApi';

export default function ForcePasswordChange({ onComplete }) {
  const [form, setForm]     = useState({ newPassword:'', confirmPassword:'' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const set = k => e => setForm(f => ({...f, [k]: e.target.value}));

  const submit = async e => {
    e.preventDefault();
    setError('');
    if (form.newPassword.length < 8)   { setError('Passordet må være minst 8 tegn'); return; }
    if (form.newPassword !== form.confirmPassword) { setError('Passordene er ikke like'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/change-password', { newPassword: form.newPassword });
      onComplete();
    } catch (err) {
      setError(err.response?.data?.error || 'Noe gikk galt');
    } finally { setLoading(false); }
  };

  const strength = (() => {
    const p = form.newPassword;
    if (!p) return null;
    let score = 0;
    if (p.length >= 8)  score++;
    if (p.length >= 12) score++;
    if (/[0-9]/.test(p)) score++;
    if (/[^a-zA-Z0-9]/.test(p)) score++;
    if (score <= 1) return { label:'Svak', color:'#F7605C', width:'25%' };
    if (score === 2) return { label:'OK',  color:'#FBBF24', width:'50%' };
    if (score === 3) return { label:'God', color:'#34D399', width:'75%' };
    return { label:'Sterk', color:'#059669', width:'100%' };
  })();

  return (
    <div style={s.overlay}>
      <div style={s.modal}>
        <div style={s.icon}>🔐</div>
        <h2 style={s.title}>Sett nytt passord</h2>
        <p style={s.desc}>
          Velkommen til Famora! For din sikkerhet må du sette et eget passord før du fortsetter.
        </p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={submit} style={s.form}>
          <label style={s.lbl}>Nytt passord</label>
          <input style={s.inp} type="password" placeholder="Minst 8 tegn"
            value={form.newPassword} onChange={set('newPassword')} autoFocus required />

          {strength && (
            <div style={s.strengthWrap}>
              <div style={{...s.strengthBar, width: strength.width, background: strength.color}} />
              <span style={{...s.strengthLabel, color: strength.color}}>{strength.label}</span>
            </div>
          )}

          <label style={s.lbl}>Bekreft passord</label>
          <input style={s.inp} type="password" placeholder="Gjenta passordet"
            value={form.confirmPassword} onChange={set('confirmPassword')} required />

          <div style={s.tips}>
            {[
              ['✅', 'Minst 8 tegn'],
              ['✅', 'Gjerne bruk tall og symboler'],
              ['✅', 'Ikke del passordet med andre'],
            ].map(([icon, text]) => (
              <div key={text} style={s.tip}><span>{icon}</span><span>{text}</span></div>
            ))}
          </div>

          <button style={{...s.btn, opacity: loading ? 0.7 : 1}} type="submit" disabled={loading}>
            {loading ? 'Lagrer…' : 'Lagre nytt passord →'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  overlay:      { position:'fixed', inset:0, background:'rgba(10,8,30,0.88)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, backdropFilter:'blur(8px)' },
  modal:        { background:'#fff', borderRadius:20, padding:'40px 36px', width:'100%', maxWidth:420, boxShadow:'0 20px 60px rgba(124,111,247,0.25)' },
  icon:         { fontSize:48, textAlign:'center', marginBottom:12 },
  title:        { fontSize:22, fontWeight:800, color:'#1A1A35', textAlign:'center', margin:'0 0 8px' },
  desc:         { fontSize:14, color:'#6B6B8A', textAlign:'center', margin:'0 0 22px', lineHeight:1.6 },
  error:        { background:'#FEE2E2', color:'#C0312D', padding:'10px 14px', borderRadius:10, fontSize:13, marginBottom:14, border:'1px solid #FECACA' },
  form:         { display:'flex', flexDirection:'column', gap:6 },
  lbl:          { fontSize:12, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase', letterSpacing:'.5px' },
  inp:          { padding:'11px 14px', borderRadius:10, border:'1px solid #EAE8F8', fontFamily:'inherit', fontSize:14, color:'#1A1A35', outline:'none', marginBottom:4 },
  strengthWrap: { height:6, background:'#EAE8F8', borderRadius:20, overflow:'hidden', position:'relative', marginBottom:12, display:'flex', alignItems:'center', gap:8 },
  strengthBar:  { height:'100%', borderRadius:20, transition:'width .3s, background .3s' },
  strengthLabel:{ fontSize:11, fontWeight:700, flexShrink:0, marginLeft:4 },
  tips:         { background:'#F7F5FF', borderRadius:10, padding:'12px 14px', marginBottom:16, display:'flex', flexDirection:'column', gap:5 },
  tip:          { display:'flex', gap:8, fontSize:12, color:'#7C6FF7', fontWeight:500 },
  btn:          { padding:'13px', borderRadius:12, border:'none', background:'#7C6FF7', color:'#fff', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer' },
};
